import { isNil } from 'rambda';
import { InstallMeterStore } from 'routes/installation/useStore';

export const selectIsHardwaresStepOK: (state: InstallMeterStore) => boolean = (state: InstallMeterStore) => {
  const { hardwares } = state;

  return !hardwares.some(({ serial_number }) => isNil(serial_number) || serial_number === '');
};
